import { useAuthStore } from "../stores/auth";
import { BrandMark } from "../components/ui/brand-mark";
import { Button } from "../components/ui/button";
import { MfaEnrolment } from "../components/mfa-enrolment";
import { blueprint } from "../blueprint";

/**
 * Écran bloquant : la double authentification est exigée sur cette instance et
 * ce compte ne l'a pas encore configurée. Rien d'autre n'est accessible.
 */
export function MfaRequired() {
  const logout = useAuthStore((s) => s.logout);
  const refresh = useAuthStore((s) => s.refresh);
  return (
    <div className="login">
      <div className="login__form login__form--wide">
        <div className="login__head">
          <BrandMark size={40} />
          <div>
            <h1 className="login__title">Sécurisez votre compte</h1>
            <p className="login__subtitle">
              {blueprint.name} exige la double authentification pour tous les comptes.
            </p>
          </div>
        </div>
        <MfaEnrolment onDone={() => void refresh()} />
        <Button variant="ghost" type="button" onClick={() => void logout()}>
          Se déconnecter
        </Button>
      </div>
    </div>
  );
}
